import { FormBase } from "core/components";

export default class ConfirmingReportFileUploadForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "file",
                    label: "CONFIRMING_REPORT.REPORT_UPLOAD.FILE_LABEL",
                    placeholder: "CONFIRMING_REPORT.REPORT_UPLOAD.FILE_PLACEHOLDER",
                    type: "file"
                }
            ]
        };
    }
}